export default __webpack_public_path__ + "static/ilustration-1-445d088642227ddf7e9fa5eecabd7ae2.png";